//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "score-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'评分单',
        url:'api/sourceRating/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'寻源项目/寻源单号/评分单号',
          searchCondition:'key',
          rules:[{field: "sourceProject-sourceNum-sourceRatingNo", option: "LIKE_ANYWHERE"}]
        },
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    goDetail(item){
      this.$router.push(`/source-score/view/${item.id}`);
    }
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/score-list.vue